import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Authentication from "../components/PageComponent/Authentication/Authentication";

import { Loader } from "../components/atoms/Loader";
import {
  initZoho,
  fetchOrgVariablesData,
  handleAuthCheckZoho,
  handleAuthenticateZoho,
} from "../util/zohoUtil";
import ModuleSetting from "../components/PageComponent/ModuleSetting/ModuleSetting";
import RelatedListSetting from "../components/PageComponent/RelatedListSetting/RelatedListSetting";
import ShowError from "../components/atoms/ShowError";
import SnackAlert from "../components/atoms/SnackAlert";
import { getCloseSnakData, snackDetails } from "../config/otherConstant";
import CronSetting from "../components/PageComponent/CronSetting/CronSetting";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function SettingsRoute() {
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [auth, setAuth] = useState(false);
  const [orgId, setOrgId] = useState(null);
  const [apiKey, setApiKey] = useState(null);
  const [zApiKey, setZApiKey] = useState(null);
  const [dataCenterUrl, setDataCenterUrl] = useState(null);
  const [dataCenter, setDataCenter] = useState(null);
  const [serviceApiKey, setServiceApiKey] = useState(null);
  const [zuid, setZuid] = useState(null);
  const [zohoLoaded, setZohoLoaded] = useState(false);
  const [snack, setSnack] = useState(snackDetails);

  const [allUsers, setAllUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState();

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack((prev) => getCloseSnakData(prev));
    // setOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    initZoho((error, extensionData) => {
      if (error || !extensionData) {
        // Set Loading false
        setLoading((prev) => false);
        // Set Error Message
        return;
      }

      const {
        serviceAuth,
        orgId,
        apiKey,
        dataCenterUrl,
        zohoLoaded,
        zohoAuth,
        serviceApiKey,
        zApiKey,
        dataCenter,
        zuid,
        allUsers,
        currentUser,
      } = extensionData;

      setOrgId((prev) => orgId);
      setApiKey((prev) => apiKey);
      setDataCenterUrl((prev) => dataCenterUrl);
      setDataCenter((prev) => dataCenter);
      setZuid((prev) => zuid);
      setAllUsers((prev) => allUsers);
      setCurrentUser((prev) => currentUser);

      setZApiKey((prev) => zApiKey);
      setServiceApiKey((prev) => serviceApiKey);
      setZohoLoaded((prev) => zohoLoaded);
      // if (serviceAuth && zohoAuth) {
      //   setAuth((prev) => true);
      //   setTabIndex((prev) => 1);
      // } else {
      //   setAuth((prev) => false);
      // }
      setLoading((prev) => false);
    });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!orgId || !apiKey || !dataCenterUrl) {
    return <ShowError />;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="basic tabs example"
        >
          <Tab label="Authentication" {...a11yProps(0)} />
          <Tab label="Module Setting" {...a11yProps(1)} disabled={!auth} />
          <Tab label="Delete Attachment" {...a11yProps(2)} disabled={!auth} />
          <Tab label="Historic Data" {...a11yProps(3)} disabled={!auth} />
        </Tabs>
      </Box>

      <Authentication
        tabIndex={tabIndex}
        index={0}
        setAuth={setAuth}
        orgId={orgId}
        apiKey={apiKey}
        dataCenterUrl={dataCenterUrl}
        dataCenter={dataCenter}
        setTabIndex={setTabIndex}
        zApiKey={zApiKey}
        serviceApiKey={serviceApiKey}
        setServiceApiKey={setServiceApiKey}
        allUsers={allUsers}
        currentUser={currentUser}
        setSnack={setSnack}
      />

      <ModuleSetting
        tabIndex={tabIndex}
        index={1}
        orgid={orgId}
        apikey={apiKey}
        datacenterurl={dataCenterUrl}
        datacenter={dataCenter}
        zuid={zuid}
        zapikey={zApiKey}
        setSnack={setSnack}
      />

      <RelatedListSetting
        tabIndex={tabIndex}
        index={2}
        orgid={orgId}
        apikey={apiKey}
        datacenterurl={dataCenterUrl}
        datacenter={dataCenter}
        zuid={zuid}
        zapikey={zApiKey}
        setSnack={setSnack}
      />

      <CronSetting
        tabIndex={tabIndex}
        index={3}
        orgid={orgId}
        apikey={apiKey}
        datacenterurl={dataCenterUrl}
        datacenter={dataCenter}
        zuid={zuid}
        zapikey={zApiKey}
        setSnack={setSnack}
      />

      <SnackAlert
        duration={snack?.duration}
        snackOpen={snack?.open}
        handleCloseSnack={handleCloseSnack}
        severity={snack?.severity}
        message={snack?.message}
      />
    </Box>
  );
}
